// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".total[data-v-021c0f57] {\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n}\n.total.notEq[data-v-021c0f57] {\n    background: #bdbdbd;\n}\n", ""]);
// Exports
module.exports = exports;
